<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="getData()"
              >
                <v-icon dark>play_arrow</v-icon>
              </v-btn>
              <span>Play</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-1"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-container
            grid-list-lg
            fluid
            style="padding: 20px 0px 0px 25px"
            class="mt-3"
          >
            <v-layout>
              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="dateFromMenu"
                  v-model="dateFromMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="dateToMenu"
                  v-model="dateToMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                md2
                style="margin-left: 15px;  margin-top: 5px; padding: 0 5px;"
              >
                <template>
                  <v-select
                    v-model="paymentType"
                    :items="paymentTypes"
                    label="Filter By Payment Type"
                    clearable
                    solo
                  ></v-select>
                </template>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[10, 20, 30, 40, 100]"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.item.index_no }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.sub_company_code }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.device_serial }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.terminal_name }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $dateFormat(props.item.transaction_date, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $dateFormat(props.item.transaction_date, "HH:mm:ss") }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.card_no_from }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.card_no_to }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.payment_type_name }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $amountInPeso(props.item.amount.toFixed(2)) }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $amountInPeso(props.item.transfer_fee.toFixed(2)) }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.user_name }}
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/CreditDetailsContainer.vue";
import XLSX from "xlsx";
var now = new Date();
var week = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 15);
import moment from "moment";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      dialogue: false,
      dialogSoldCredit: false,
      dialogCreditRedeem: false,
      companies: [],
      subcompanies: [],
      assignCompany: "",
      assignSubCompany: "",

      cancelDialog: false,
      cancelType: "",
      remarksDialog: false,

      confirmLoading: false,
      dialogLoading: false,
      items: [],
      title: "Transfer",
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Merchant Code",
          align: "left",
          value: "merchant_code",
          sortable: false,
        },
        {
          text: "Device Serial",
          align: "center",
          value: "device_serial",
          sortable: false,
        },
        {
          text: "Branch",
          align: "center",
          value: "branch",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "From",
          align: "center",
          value: "from",
          sortable: false,
        },
        {
          text: "To",
          align: "center",
          value: "to",
          sortable: false,
        },
        {
          text: "Payment Type",
          align: "center",
          value: "payment_type",
          sortable: false,
        },
        {
          text: "Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
        {
          text: "Fee",
          align: "center",
          value: "fee",
          sortable: false,
        },
        {
          text: "Cashier Name",
          align: "center",
          value: "cashier_name",
          sortable: false,
        },
      ],
      data: {},
      valid: true,
      viewData: {},
      queryParams: {
        search: null,
        date_from: null,
        date_to: null,
        payment_type: null,
      },
      dialogLoading: false,
      dialogType: "",
      dialogTitle: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      valid: true,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      uploadLoading: false,
      valid: true,
      creditRedeemItems: [],
      soldCreditItems: [],
      paymentType: "",
      paymentTypes: [],
    };
  },
  created: async function() {
    await this.getPaymentType();
  },
  computed: {
    pageLimit: {
      get() {
        return 1;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    paymentType: async function() {
      if (
        this.paymentType !== null &&
        this.paymentType !== undefined &&
        this.paymentType !== "".type
      ) {
        // this.queryParams.offset = 0;
        // this.queryParams.status = this.paymentType;
        this.getData();
      } else {
        // this.queryParams.offset = 0;
        // this.queryParams.status = null;
        this.getData();
      }
    },
  },
  methods: {
    async getPaymentType() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      try {
        // Query Data
        let response = (await Services.getPaymentTypes(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        await response.data.forEach(async (item) => {
          await this.paymentTypes.push({
            text: item.name.toUpperCase(),
            value: item.name.toLowerCase(),
          });
        });
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      // this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;
      this.queryParams.payment_type = this.paymentType;

      try {
        // Query Data
        let response = (await Services.getTransferTransaction(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    openFilterExpansion() {
      this.openFilter = !this.openFilter;
    },
    daysDiff(expiration_date) {
      const days = moment(expiration_date).diff(now, "days");
      return days <= 0 ? "Lapse" : days;
    },
    async getSoldCredit(card_no) {
      this.$store.dispatch("startLoading");
      this.dialogSoldCredit = true;

      const params = {
        card_no,
      };

      try {
        const response = (await Services.getSoldCreditDetails(params)).data;

        this.soldCreditItems = new Array(response.data);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.$store.dispatch("endLoading");
      }

      setTimeout(() => {
        this.dialogLoading = false;
        this.$store.dispatch("endLoading");
      }, 600);
    },
    async getCreditRedeem(card_no) {
      this.$store.dispatch("startLoading");
      this.dialogCreditRedeem = true;

      const params = {
        card_no,
      };

      try {
        const response = (await Services.getCreditRedeemDetails(params)).data;

        this.creditRedeemItems = new Array(response.data);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.$store.dispatch("endLoading");
      }

      setTimeout(() => {
        this.dialogLoading = false;
        this.$store.dispatch("endLoading");
      }, 600);
    },
    async resendCode(card_no) {
      this.$store.dispatch("startLoading");
      const body = {
        card_number: card_no,
      };

      try {
        const response = await Services.resendCode(body);

        if (response.status === 201 || response.status === 200) {
          this.$infoBar({
            type: "success",
            text: "Code Sent!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: `${this.$capitalizeFirstLetter(error.response.data.message)}`,
          });
        }
        this.$store.dispatch("endLoading");
      }
      this.$store.dispatch("endLoading");
    },
    async regenerateCode(card_no) {
      this.$store.dispatch("startLoading");
      const body = {
        card_number: card_no,
      };

      try {
        const response = await Services.regenerateCode(body);

        if (response.status === 201 || response.status === 200) {
          this.$infoBar({
            type: "success",
            text: "Code Regenerated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: `${this.$capitalizeFirstLetter(error.response.data.message)}`,
          });
        }
        this.$store.dispatch("endLoading");
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog(type) {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.dialogTitle = type;

      if (type === "Replenish") {
        await this.setCompanies();
      }

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.nextWeek = this.$dateFormat(week, "YYYY-MM-DD");

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.dialogTitle = this.title;

      this.viewData = await this.setData(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async saveCancelDialog() {
      this.confirmLoading = true;
      console.log(this.$refs.remark.remarks);
      try {
        const body = {
          id: this.viewData.id,
          remarks: this.$refs.remark.remarks,
        };
        const response = await Services.cancelCredit(body);
        if (response.status === 200 || response.status === 201) {
          this.closeCancelDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Credit has been canceled!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeCancelDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.confirmLoading = false;
    },
    async openCancelDialog(data) {
      // this.cancelDialog = true;
      this.remarksDialog = true;
      this.viewData.id = data.id;
    },
    async closeCancelDialog() {
      // this.cancelDialog = false;
      this.remarksDialog = false;
    },
    async setData(items) {},
    closeDialog() {
      if (this.dialogLoading === false && this.dialogTitle === "Dispute") {
        this.$refs.form.reset();
      }

      if (this.dialogLoading === false && this.dialogTitle === "Replenish") {
        this.$refs.formCompany.reset();
        this.$refs.formSubCompany.reset();
        this.$refs.formReplenish.reset();
      }

      if (this.dialogLoading === false && this.dialogTitle === "Promo") {
        this.$refs.formPromo.reset();
      }

      this.e1 = 0;
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogTitle = "";
      this.dialogType = "";
      this.dialogStatus = false;
      this.promoDialog = false;
      this.uploadItems = [];
    },
    saveDialog() {
      if (this.dialogTitle === "Dispute") {
        if (this.$refs.form.validate()) {
          this.openConfirmDialog = true;
        }
      }
      if (this.dialogTitle === "Replenish") {
        if (this.$refs.formReplenish.validate()) {
          this.openConfirmDialog = true;
        }
      }
      if (this.dialogTitle === "Promo") {
        if (this.$refs.formPromo.validate()) {
          this.openConfirmDialog = true;
        }
      }
    },
    async setCompanies() {
      this.companies = [];
      const items = (await Services.getCompanies({})).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.companies.push(data);
      }
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const items = (
        await Services.getSubCompanies({
          company_id: this.assignCompany.value,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.subcompanies.push(data);
      }
    },

    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    refreshData() {
      this.items = [];

      this.queryParams.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.queryParams.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.queryParams.limit = 10;
      this.queryParams.offset = 0;
      this.queryParams.status = null;

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.paymentType = "";
      this.totalItems = 0;

      this.getData();
    },
    async downloadExcel() {
      // if (this.items.length == 0) return;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];
        theItem.push(this.items[e].index_no);
        theItem.push(this.items[e].sub_company_code);

        theItem.push(this.items[e].device_serial);
        theItem.push(this.items[e].terminal_name.toUpperCase());

        theItem.push(
          this.$dateFormat(this.items[e].transaction_date, "YYYY-MM-DD"),
        );
        theItem.push(
          this.$dateFormat(this.items[e].transaction_date, "HH:mm:ss"),
        );
        theItem.push(this.items[e].card_no_from);
        theItem.push(this.items[e].card_no_to);
        theItem.push(this.items[e].payment_type_name.toUpperCase());

        theItem.push(this.items[e].amount);
        theItem.push(this.items[e].transfer_fee);

        theItem.push(this.items[e].user_name);

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>
<style scoped>
button:disabled,
button[disabled] {
  border: 1px solid #d0cdcd;
  background-color: #d0cdcd;
  color: #d0cdcd;
}
button:disabled,
button[disabled] svg {
  color: #d0cdcd;
}
</style>
